module.exports = {
    record: {
        search: '検索する',
        sure: 'よし',
        expList:"エクスポート",
        expHint:{
            errorMsg:"エクスポートに失敗しました。やり直してください",
            successMsg:"レコードエクスポート成功",
        },
        table: {
            index: '番号',
            mac: 'MACアドレス',
            commodity: 'ID',
            updateTime: '更新時間',
            type: '操作タイプ',
            result: '運用実績',
            operator: 'オペレーター',
            // updateLabel:'更新标签',
            // updateLabel1:'更新标签',
            // upgradeESL:'升级标签',
            // upgradeESL1:'升级标签',
            // updateSucceeded:'更新成功',
            // updateSucceeded1:'更新成功',
            // updateFailed:'更新失败',
            // updateFailed1:'更新失败',
            // upgradeESLSucceeded:'升级成功',
            // upgradeESLSucceeded1:'升级成功',
            // upgradeESLFailed:'升级失败',
            // upgradeESLFailed1:'升级失败'

        },
        hintMsg: {
            queryRecordFail: 'クエリログレコードが失敗しました'
        },
        // operation:[{
        //     name:'Update ESL',
        //     value:'更新标签'
        // },{
        //     name:'Update succeeded',
        //     value:'更新成功'
        // },{
        //     name:'Update failed',
        //     value:'更新失败'
        // }],


        operationType: [{ //操作类型
            value: '',
            label: 'すべての操作タイプ'
        }, {
            value: '1',
            label: 'ラベルを更新'
        }, {
            value: '2',
            label: 'アップグレードタブ'
        }],
        operationResult: [{ //操作结果
                result: [{
                    value: '',
                    label: 'すべての操作結果'
                }]
            }, {
                result: [{ //更新标签
                    value: '1',
                    label: '正常に更新されました'
                }, {
                    value: '2',
                    label: '更新できませんでした'
                }, {
                    value: '3',
                    label: '不正なラベルキー'
                }, {
                    value: '7',
                    label: '更新タイムアウト'
                }, {
                    value: '9',
                    label: '画面が破損している'
                }, {
                    value: '10',
                    label: 'オフラインのゲートウェイ'
                }, {
                    value: '11',
                    label: 'テンプレートが間違っているか、存在しません'
                }, {
                    value: '12',
                    label: 'ゲートウェイハードウェア異常'
                }, {
                    value: '13',
                    label: '一貫性のないファームウェアと画面'
                }]
            },
            {
                result: [{ //升级标签
                    value: '3',
                    label: '不正なラベルキー'
                }, {
                    value: '4',
                    label: 'アップグレード成功'
                }, {
                    value: '5',
                    label: 'アップグレードに失敗しました'
                }, {
                    value: '6',
                    label: 'アップグレードパッケージのエラー'
                }, {
                    value: '8',
                    label: 'アップグレードのタイムアウト'
                }, {
                    value: '10',
                    label: 'オフラインのゲートウェイ'
                }, {
                    value: '12',
                    label: 'ゲートウェイハードウェア異常'
                }]
            }
        ],
        typeAndResult: [{ //操作类型和操作结果映射关系,按顺序获取
            key: '',
            value: 0
        }, {
            key: '1',
            value: 1
        }, {
            key: '2',
            value: 2
        }],
        type: {
            // resultAll:'全部操作结果'
            // operationTypeMsg:'请选择操作类型',
            // operationResultMsg:'请选择操作结果'
        }

    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/record.js